import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import { es, enGB } from 'date-fns/locale';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import Icon from '~/components/Icon';
import * as S from './styles';

export default function Picker({
  label,
  dateFilter,
  setDateFilter,
  options,
  isLoading,
}) {
  const { t } = useTranslation();

  const filteredDates = () => {
    return options.map(opt => {
      return new Date(opt.date);
    });
  };

  return (
    <S.Container>
      <S.Label>{label}</S.Label>
      <S.InputWrapper>
        <DatePicker
          disabled={isLoading}
          selected={dateFilter ? new Date(dateFilter) : null}
          isClearable
          onChange={e => {
            setDateFilter(e ? format(e, 'yyyy-MM-dd') : null);
          }}
          includeDates={filteredDates()}
          showYearDropdown
          customInput={
            <S.Picker dateSelected={dateFilter !== null}>
              {dateFilter !== null
                ? format(new Date(dateFilter), 'dd/MM/yyyy')
                : t('allFemale')}
              <div>
                <Icon name="calendar" size={20} color="white" />
                {isLoading && <Icon name="dots" size={15} color="gray" />}
              </div>
            </S.Picker>
          }
          locale={t('languageId') === 'ES' ? es : enGB}
        />
      </S.InputWrapper>
    </S.Container>
  );
}

Picker.propTypes = {
  label: PropTypes.string,
  dateFilter: PropTypes.string,
  setDateFilter: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};

Picker.defaultProps = {
  label: '',
  setDateFilter: () => {},
  dateFilter: null,
  options: [],
  isLoading: false,
};
